import React from 'react';
import agent from '../../../../agent';
import SavedSearchStackedBarChartWidget from './SavedSearchStackedBarChartWidget'
import LoaderWidget from '../Loader/LoaderWidget'
import {checkForUnauthorisedResponse} from '../../../Utils/ErrorHandler'

class SavedSearchStackedBarChartWidgetContainer extends React.Component {

  constructor() {
    super();
    this.state = {
      search: {
        rows:[]
      },
      loaded:false
    };
  }

  componentDidMount() {
    this.refresh();
  }

  refresh() {
    this.runSearch(this.props.savedSearchId, this.props.bypassCache, this.props.yAxisColumns, this.props.xAxisColumn);
  }

  runSearch(savedSearchId, bypassCache, yAxisColumns, xAxisColumn) {
    agent.Search.executeStackedBarChartSearch(savedSearchId, bypassCache, yAxisColumns, xAxisColumn).then(
      res => {
        if(res.result) {
          this.setState({
            ...this.state,
            'search':res.data,
            loaded:true
          })
        } else {
          this.setState({
            ...this.state,
            loaded:true
          })
        }
      },
      error => {
        if(!checkForUnauthorisedResponse(error, agent)) {
          this.setState({
            ...this.state,
            loaded:true
          })
        }
      }
    )

  }


  render() {
    if(this.state.loaded) {
      return (
        <SavedSearchStackedBarChartWidget {...this.props} onWidgetRefresh={this.refresh.bind(this)} search={this.state.search} />
      )
    } else {
      return (
        <LoaderWidget {...this.props}/>
      )
    }

  }
}

export default SavedSearchStackedBarChartWidgetContainer;



// WEBPACK FOOTER //
// ./src/components/Dashboard/components/SavedSearchStackedBarChartWidget/SavedSearchStackedBarChartWidgetContainer.js